export default {
  path: '/options',
  name: 'options',
  component: () => import('../components/option/Layout'),
  redirect: { name: 'OptionList' },
  meta: {
    breadcrumb: 'profile.option.options',
  },
  children: [
    {
      name: 'OptionList',
      path: '',
      component: () => import('../views/option/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'OptionCreate',
      path: 'new',
      component: () => import('../views/option/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'OptionUpdate',
      path: ':id/edit',
      component: () => import('../views/option/Update'),
      meta: {
        breadcrumb: 'profile.option.option',
      },
    },
    {
      name: 'OptionShow',
      path: ':id',
      component: () => import('../views/option/Show'),
      meta: {
        breadcrumb: 'profile.option.option',
      },
    },
    {
      name: 'Option',
      path: ':parent',
      component: () => import('../components/producttypefile/Layout'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefiles',
      },
      children: [
        {
          name: 'ProducttypefileOptionMachineCreate',
          path: 'new',
          component: () => import('../views/producttypefile/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
